import { config } from "../config/Config"
import type { Breadcrumb } from "../redux/index/index.types"

export function storeBreadcrumbs(crumbs: Breadcrumb[]) {
  localStorage.setItem(config.breadcrumbLocalstorageKey, JSON.stringify(crumbs))
}

export function getStoredBreadcrumbs(): Breadcrumb[] {
  const json: string | null = localStorage.getItem(config.breadcrumbLocalstorageKey)
  if (json === null) return []
  return JSON.parse(json)
}

export function clearBreadcrumbs(): void {
  localStorage.removeItem(config.breadcrumbLocalstorageKey)
}
